import { Results } from "@search/components/Results";

function SearchLayout() {
  return <Results />;
}

export default SearchLayout;
export { SearchLayout };
